import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, PUT, DELETE } from "../../../../services/index";
import { message } from "antd";

// รายการ blacklist ทั้งหมดของบริษัท (company จาก header, server-side pagination + search)
export const useBlacklistList = ({ page = 1, pageSize = 20, search = "" }) => {
  return useQuery(
    ["blacklistList", page, pageSize, search],
    async () => {
      const params = new URLSearchParams({ page, pageSize, search });
      const { result } = await GET(`/api/v1/blacklist?${params.toString()}`);
      return result || { data: [], total: 0, page, pageSize, totalPages: 0 };
    },
    {
      keepPreviousData: true,
      onError: async () => {
        await message.destroy();
        message.error("โหลดรายการ blacklist ไม่สำเร็จ");
      },
    }
  );
};

// แก้ไข / ลบ (เตรียมไว้ — UI ซ่อนด้วย SHOW_EDIT_DELETE ในหน้า)
export const useUpdateBlacklistEntry = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }) => await PUT(`/api/v1/blacklist/${id}`, payload),
  });
};

export const useDeleteBlacklistEntry = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/blacklist/${id}`),
  });
};
